import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store";
import { get_company_branches } from "../../../services/apis/companies";
import DataTable from "../../../component/element/table";
import { ColumnDef } from "@tanstack/react-table";
import { ICompanyBranch } from "../../../store/types/companies";

type IBranches = {
  companyId: number;
};

const CompanyBranch: React.FC<IBranches> = ({ companyId }) => {
  const dispatch = useAppDispatch();
  const branches = useAppSelector(({ companies }) =>
    companies.branchesCompanyId === companyId ? companies.branches : [],
  );
  const loading = useAppSelector(
    ({ companies }) =>
      companies.branchesCompanyId === companyId && companies.branchesLoading,
  );

  // Fetch branches when companyId changes
  useEffect(() => {
    if (Number.isInteger(companyId) && companyId > 0) {
      get_company_branches(dispatch, companyId);
    }
  }, [companyId, dispatch]);

  const columns: ColumnDef<ICompanyBranch>[] = [
    {
      accessorKey: "name",
      header: () => <span>Branch</span>,
    },
    {
      accessorKey: "address",
      header: () => <span>Address</span>,
    },
  ];

  return loading ? (
    <div className="py-12 text-center text-gray-500">Loading branches...</div>
  ) : (
    <DataTable columns={columns} data={branches} hasPaginate={false} />
  );
};

export default CompanyBranch;
